import { CheckIcon, WarningIcon } from '@axa-japan/design-system-react/Icons';
import Text from '@axa-japan/design-system-react/Text';
import Picture1Dialog from '../../assets/Picture1Dialog.png';
import Picture2Dialog from '../../assets/Picture2Dialog.png';
import Heading from '@axa-japan/design-system-react/Heading';

const UserGuideUploadModal = () => {
  return (
    <div className="flex flex-col gap-4">
      <div className="flex">
        <WarningIcon isOutline />
        <Text>記載内容がはっきり読めるよう、書類全体を写してください。</Text>
      </div>
      <div className="bg-statusInformationLight w-full p-5 flex flex-col items-center gap-5">
        <div className="flex text-statusInformation items-center gap-3">
          <CheckIcon isStroke />
          <Heading>正しい撮影例</Heading>
        </div>
        <div className="flex w-full gap-3">
          <img src={Picture1Dialog} className="w-1/2" />
          <img src={Picture2Dialog} className="w-1/2" />
        </div>
      </div>
    </div>
  );
};

export default UserGuideUploadModal;
